interface ErrorBannerProps {
  message: string;
  onDismiss?: () => void;
}

export function ErrorBanner({ message, onDismiss }: ErrorBannerProps) {
  return (
    <div
      style={{
        background: '#ffebee',
        border: '1px solid #ef9a9a',
        borderRadius: 6,
        padding: '10px 14px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: '#c62828',
        fontSize: 14,
        margin: '8px 0',
      }}
    >
      <span>{message}</span>
      {onDismiss && (
        <button
          onClick={onDismiss}
          style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, color: '#c62828', padding: '0 4px' }}
        >
          ×
        </button>
      )}
    </div>
  );
}
